const KEY = "baianeira_coupon";

export function saveCoupon(coupon) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...coupon, saved_at: new Date().toISOString() }));
  } catch {
    // storage pieno o non disponibile: il coupon resta comunque a schermo
  }
}

export function loadCoupon() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.code || !data?.expires_at) return null;
    if (new Date(data.expires_at) <= new Date()) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}
